import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.997 18.958c-4.941 0-8.958-4.017-8.958-8.959s4.017-8.958 8.958-8.958c4.942 0 8.959 4.017 8.959 8.958 0 4.942-4.017 8.959-8.959 8.959m0-16.667c-4.25 0-7.708 3.458-7.708 7.708s3.458 7.709 7.708 7.709 7.709-3.459 7.709-7.709-3.459-7.708-7.709-7.708"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.639 12.982a.62.62 0 0 1-.442-.183.63.63 0 0 1 0-.883l4.717-4.717a.63.63 0 0 1 .883 0 .63.63 0 0 1 0 .883L8.08 12.8a.6.6 0 0 1-.441.183"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.355 12.982a.62.62 0 0 1-.441-.183L7.197 8.082a.63.63 0 0 1 0-.883.63.63 0 0 1 .883 0l4.717 4.717a.63.63 0 0 1 0 .883.62.62 0 0 1-.442.183"
    }, null, -1)
  ]))]))
}
export default { render: render }